import type { RedcatAnalyticsStore } from '../types/store';
import type { PaymentEventBase, PaymentFailureReason } from '../types/payment';
import { PaymentTrackEventName } from '../types/payment';
import type { PaymentTrackEvent } from '../types/events/track';
import { paymentEventProperties } from './paymentEventProperties';

export const trackPaymentFailed = (
  track: RedcatAnalyticsStore['track'],
  { failureReason, ...base }: PaymentEventBase & { failureReason: PaymentFailureReason },
) => {
  const event: PaymentTrackEvent = {
    name: PaymentTrackEventName.PaymentFailed,
    properties: {
      ...paymentEventProperties(base),
      failure_reason: failureReason,
    },
  };

  track(event);
};
